import getImage from './GetImage';
import pdfMake from 'pdfmake/build/pdfmake.js';
import { calculateAgeParse } from '../../../../Utils/Patient';
import htmlToPdfmake from "html-to-pdfmake";
import moment from 'moment';

const createFormat = async (data) => {

    //this.setState({ showPDf: true });
    console.log(data);
    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    const fecha = data.today;
    const name = data.typeOfDocument + '-' + data.documentNumber + ' ' + data.names;
    let services = [];

    const namesPlan = !!data.plansName ? ' - ' + data.plansName : '';

    let htmlCertAdmission = null;
    if (data.hasOwnProperty("templete")) {
        htmlCertAdmission = htmlToPdfmake(data.templete, {
            p: { fontSize: 8 },
            defaultStyles: {
                table: {
                    width: ['*', "auto"]
                }
            },
            tableAutoSize: true
        });
    } else {
        htmlCertAdmission = null;
    }

    services.push([{ text: 'Procedimientos', style: 'tableheader' }]);

    let textCertificateServices = "";

    if (data.servicios.length > 1) {
        textCertificateServices = `Certifico que Recibo de ${data.profile.nombre} los servicios de:`;
    }
    else {
        textCertificateServices = `Certifico que Recibo de ${data.profile.nombre} el servicio de:`;
    }

    services.push([{ text: textCertificateServices, style: 'textStyle' }]);
    services.push([{ text: '', style: 'textStyle' }]);

    for (let obj of data.servicios) {
        services.push([{ text: obj.codigo + ' - ' + obj.nombre, style: 'textStyle', margin: [0, -8, 0, 0] }])
    }

    console.log(services);

    let urlServe = process.env.REACT_APP_PUBLIC_URL + 'profesional/ver-firma/' + data.id_profesional + '/' + sessionStorage.getItem('token');
    let urlFirma = '';

    let test = fetch(urlServe)
        .then(response => {
            if (response.status === 500) {
                return false;
            } else {
                return true;
            }
        });

    let isImg = await test;

    if (isImg) {
        urlFirma = urlServe;
    } else {
        urlFirma = 'https://i.postimg.cc/0jznYVsr/prueba.png';
    }

    let urlFirmaPaciente = 'https://i.postimg.cc/0jznYVsr/prueba.png';


    const header = {
        margin: [40, 5, 0, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', '*'],
            body: [
                [{
                    image: await getImage(data.urlLogo),
                    fit: [100, 40],
                },
                { text: data.profile.nombre + '\n Nit:' + data.profile.nit + '\n ' + data.profile.direccion.direccion, style: 'head' }
                ],
            ]
        },
    };

    /* const header = {
        margin: [5, 5, 5, 0],
        layout: 'noBorders',
        table: {
            heights: 40,
            widths: ['*', '*'],
            body: [
                [{
                    image: await getImage(data.urlLogo),
                    fit: [150, 75],
                },
                {
                    table: {
                        body: [
                            [{ text: data.profile.nombre, style: 'head', bold: true }],
                            [{ text: 'Dirección: ' + data.profile.direccion.direccion + ' ' + 'Teléfono:' + data.profile.telefono1, style: 'textStyle', bold: true }],
                            [{ text: 'NIT: : ' + data.profile.nit, style: 'head', bold: true }]
                        ]
                    },
                }],
            ],
        },
    }; */

    const foter = (currentPage, pageCount) => {
        return {
            table: {
                widths: ['*', '*', '*'],
                body: [
                    [{ text: "Página " + currentPage.toString() + ' de ' + pageCount, style: 'foter' }, { text: name, style: 'foter' }, { text: 'Fecha Impresión: ' + data.today, style: 'foter' }],
                ]
            },
            layout: 'noBorders',
            margin: [20, 0, 0, 5],
        };
    }

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        header: header,
        pageMargins: [20, 50, 20, 20],
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: [300, 'auto'],
                    body: [
                        [{
                            margin: [0, 10, 0, 10],
                            text: 'Ingreso No. ' + data.id_admision,
                            style: 'tableheader'
                        },
                        {
                            margin: [0, 10, 0, 0],
                            text: 'Certificado de Atención a Pacientes',
                            style: 'tableheader'
                        }],
                        [{
                            margin: [0, -15, 0, 0],
                            text: '',
                        },
                        {
                            margin: [0, -15, 0, 0],
                            bold: true,
                            text: 'Resolución 003047 de 2008',
                            style: 'textStyle'
                        }],
                    ]
                },
                layout: 'noBorders'
            },
            {
                margin: [0, 0, 0, 0],
                layout: {
                    defaultBorder: false,
                },
                table: {
                    widths: ['auto', '*', 'auto', '*', 'auto', '*'],
                    body: [
                        [{ text: 'F.Ingreso: ', style: 'textStyleInfoTop', bold: true, border: [false, true, false, false] }, { text: data.fecha + ' - ' + data.hora, style: 'textStyleInfoTop', border: [false, true, false, false] }, { text: 'Documento', bold: true, style: 'textStyleInfoTop', border: [false, true, false, false] }, { text: data.typeOfDocument + '-' + data.documentNumber, style: 'textStyleInfoTop', border: [false, true, false, false] }, { text: 'F.Nacimiento ', bold: true, style: 'textStyleInfoTop', border: [false, true, false, false] }, { text: moment(data.birthday).format('DD-MM-YYYY'), style: 'textStyleInfoTop', border: [false, true, false, false] }],
                        [{ text: 'Paciente ', bold: true, style: 'textStyleInfoTop' }, { text: data.names, style: 'textStyleInfoTop', colSpan: 3 }, '', '', { text: 'Edad ', bold: true, style: 'textStyleInfoTop' }, { text: calculateAgeParse(data.birthday), style: 'textStyleInfoTop' }],
                        [{ text: 'Dirección ', bold: true, style: 'textStyleInfoTop' }, { text: data.direccion, style: 'textStyleInfoTop', colSpan: 3 }, '', '', { text: 'Celular: ', bold: true, style: 'textStyleInfoTop' }, { text: data.celular, style: 'textStyleInfoTop' }],                        
                        [{ text: 'Telefono ', bold: true, style: 'textStyleInfoTop', border: [false, false, false, false] }, { text: data.telefono, style: 'textStyleInfoTop', border: [false, false, false, false] }, '', '', '', ''],
                        [{ text: 'Genero ', bold: true, style: 'textStyleInfoTop', border: [false, false, false, true] }, { text: data.gender, style: 'textStyleInfoTop', border: [false, false, false, true] }, { text: 'Tipo de Sangre: ', bold: true, style: 'textStyleInfoTop', border: [false, false, false, true] }, { text: data?.infoAdmission?.tipo_sangre, style: 'textStyleInfoTop', border: [false, false, false, true], colSpan: 3 }, '', '']
                    ]
                }
            },
            {
                margin: [0, 0, 0, 0],
                layout: {
                    defaultBorder: false,
                },
                table: {
                    widths: ['auto', '*', 'auto', '*', 'auto', '*'],
                    body: [
                        [{ text: 'Medico ', bold: true, style: 'textStyleInfoTop' }, { text: data.professional.nombres + ' ' + data.professional.apellido1 + ' ' + data.professional.apellido2, style: 'textStyleInfoTop', colSpan: 3, border: [false, false, false, false] }, '', '', { text: 'Autorización No. ', bold: true, style: 'textStyleInfoTop', border: [false, false, false, false] }, { text: data?.infoAdmission?.admision?.codigo_autorizacion, style: 'textStyleInfoTop', border: [false, false, false, false] }],
                        [{ text: 'Entidad: ', style: 'textStyleInfoTop', bold: true, border: [false, false, false, true] }, { text: data.thirdName + namesPlan, style: 'textStyleInfoTop', colSpan: 3, border: [false, false, false, true] }, '', '', { text: 'Validación No. ', bold: true, style: 'textStyleInfoTop', border: [false, false, false, true] }, { text: data?.infoAdmission?.admision?.codigo_validacion, style: 'textStyleInfoTop', border: [false, false, false, true] }],
                    ]
                }
            },
            {
                margin: [0, 0, 0, 0],
                layout: 'noBorders',
                style: 'tableText',
                table: {
                    widths: ['*'],
                    body: [
                        [htmlCertAdmission],
                    ]
                }
            },
            /* {
                // auto-sized columns have their widths based on their content                                       
                margin: [40, 60, 0, 0],
                layout: 'headerLineOnly',
                table: {
                    widths: [100],
                    headerRows: 1,
                    body: [
                        [{ text: '' }],
                        [{ text: 'Firma y Cedula', style: 'textStyle', }],

                    ]
                },
            }, */
            /* {
                margin: [0, 10, 0, 0],
                text: 'Autorizar a los medicos de ' + data.profile.nombre + '. a consultar los datos de mi historia clinica y examenes del diagnostico, preservando siempre '
                    + 'la confidencialidad, con el fin de que sean utilizados, analizados, y revisados, para fines estadisticos y desarrollo de la ciencia médica \n Sí otorgo, ', style: 'paragraf',
            }, */
            {
                // auto-sized columns have their widths based on their content                                       
                columns: [
                    {
                        // auto-sized columns have their widths based on their content                                       
                        margin: [20, 10, 25, 0],
                        layout: 'headerLineOnly',
                        table: {
                            widths: [100],
                            headerRows: 1,
                            body: [
                                [{
                                    image: await getImage(urlFirmaPaciente),
                                    fit: [35, 35],
                                }],
                                [{ text: 'Firma y Cedula', style: 'tableText', }],
                            ]
                        },
                    },
                    /* {
                        // auto-sized columns have their widths based on their content                                       
                        margin: [40, 30, 25, 0],
                        layout: 'headerLineOnly',
                        table: {
                            widths: [100],
                            headerRows: 1,
                            body: [
                                [{
                                    image: await getImage(urlFirma),
                                    fit: [80, 80],
                                }],
                                [{ text: 'Firma del Medico', style: 'textStyle', }],

                            ]
                        },
                    }, */
                ],
                columnGap: 40
            },
        ],
        styles: {
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left',
                font: 'OpenSans'
            },
            tableheader: {
                fontSize: 10,
                bold: true,
                font: 'OpenSans'
            },
            textStyle: {
                fontSize: 9,
                font: 'OpenSans'
            },
            textStyleInfoTop: {
                fontSize: 7.5,
                font: 'OpenSans'
            },
            paragraf: {
                fontSize: 10,
                alignment: 'justify',
                font: 'OpenSans'
            },
            foter: {
                margin: 10,
                fontSize: 6,
                font: 'OpenSans'
            },
            medicStyle: {
                margin: [0, 80, 0, 0],
                fontSize: 10,
                alignment: 'left',
                font: 'OpenSans'
            },
            tableText: {
                fontSize: 8,
                font: 'OpenSans'
            },
        }
    };

    //pdfMake.createPdf(documentDefinition).open();
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
}

export default createFormat;